export default "__VITE_ASSET__DkddQNoA__"